<div class="orders py-3 pt-5 pagination-workflow">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <div class="prospects-panel d-flex justify-content-between ms-2 me-auto">
      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="Delivery exception"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="true"
          (click)="getDeliveryStatusOnChange($event)" />
        <span class="link">Delivery Exception</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="Delivered"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getDeliveryStatusOnChange($event)" />
        <span class="link">Delivery Status</span>
      </label>
    </div>
    <div class="lds-ring inline me-auto sm-loader" *ngIf="showSmallLoader">
      <jni-spinner></jni-spinner>
    </div>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcelForFilterData()">Export excel</a>
      </div>
    </div>
  </header>
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="statusList"
    styleClass="p-datatable-customers ordersListing search-more"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
    [paginator]="true"
    [filterDelay]="0"
    selectionMode="single"
    [rows]="defaultTake"
    [lazy]="true"
    (onLazyLoad)="getWorkflowDeliveryStatuses($event)"
    [totalRecords]="totalCount"
    sortMode="multiple">
    <ng-template pTemplate="header">
      <tr>
        <th class="name">Proposed Project</th>
        <th class="name">Sales Order</th>
        <th class="name">Tracking Number</th>
        <th class="number">Line Number</th>
        <th class="name">Nickname</th>
        <th class="name">Shipping Method</th>
        <th *ngIf="deliveryStatus === 'Delivery exception'" class="status">
          Delivery Exception
        </th>
        <th *ngIf="deliveryStatus === 'Delivered'" class="status">
          Delivery Status
        </th>
        <th *ngIf="deliveryStatus === 'Delivery exception'" class="status">
          Description
        </th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="workflowId"
              (input)="onFilterInput($event)"
              [showMenu]="false">
            </p-columnFilter>
          </div>
        </th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="salesOrderIdD365"
              (input)="onFilterInput($event)"
              [showMenu]="false">
            </p-columnFilter>
          </div>
        </th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="trackingNumber"
              (input)="onFilterInput($event)"
              [showMenu]="false">
            </p-columnFilter>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="nickName"
              (input)="onFilterInput($event)"
              [showMenu]="false">
            </p-columnFilter>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <p-columnFilter
              type="text"
              field="deliveryStatus"
              (input)="onFilterInput($event)"
              [showMenu]="false">
            </p-columnFilter>
          </div>
        </th>
        <th *ngIf="deliveryStatus === 'Delivery exception'"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-statusList let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="statusList"
        [pSelectableRowIndex]="rowIndex">
        <td>{{ getPaddedWorkflowId(statusList.workflowId) }}</td>
        <td>{{ statusList.salesOrderIdD365 }}</td>
        <td>{{ statusList.trackingNumber }}</td>
        <td>{{ statusList.lineNumber }}</td>
        <td>{{ statusList.nickName }}</td>
        <td>
          {{
            getShippingMethodDisplay(
              statusList.shippingMethodName,
              statusList.carrierShippingMethod
            )
          }}
        </td>
        <td>{{ statusList.deliveryStatus }}</td>
        <td *ngIf="deliveryStatus === 'Delivery exception'">
          {{ statusList.exceptionDescription }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No record found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
